import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    breadcrumbsWrapper: 'relative w-full lg:mx-auto lg:max-w-360',
    breadcrumbs: 'absolute top-5 z-10 lg:top-8',
    image: 'w-full object-cover lg:h-full',
    title: 'leading-[1.2] font-extrabold lg:whitespace-pre-wrap',
    text: 'lg:whitespace-pre-wrap',
    description:
      'lg:text-m mt-2 text-xs leading-[1.4] font-light lg:mt-3 lg:leading-[1.5] lg:whitespace-pre-wrap',
    label: 'absolute -top-3 lg:relative lg:-top-2',
    button:
      'max-lg:hover:bg-primary hover:text-text-main inline-flex min-w-50 text-base',
    arrowPrev: 'left-10',
    arrowNext: 'right-10',
    carousel: '[--slide-size:100%]',
    banner:
      'bg-accent relative w-full after:absolute after:top-0 after:right-0 after:bottom-0 after:left-0 after:bg-[#10060166]',
    wrapper: 'lg:mx-auto lg:max-w-360',
    content:
      'absolute bottom-[54px] left-0 z-1 max-w-[64%] lg:bottom-1/2 lg:max-w-full lg:translate-y-1/2',
    dots: 'absolute right-0 left-0 mx-auto w-full lg:max-w-360',
    arrow: '',
    link: '',
    buttonWrapper: '',
    date: 'absolute top-6 left-6 z-100 flex items-center justify-center rounded-full bg-white px-[12px] py-[5.5px] text-[12px] leading-[140%] lg:top-3 lg:left-3'
  },
  variants: {
    type: {
      main: {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 lg:left-35',
        image: 'h-full',
        banner: 'min-h-128 lg:h-203',
        title: 'text-[32px] lg:mb-4 lg:pt-0 lg:text-5xl',
        text: 'mt-2 text-lg leading-[1.4] lg:text-2xl',
        button: 'max-lg:bg-primary mt-6 lg:mt-12',
        content: 'pl-3 lg:ml-24 lg:px-0',
        dots: 'bottom-[18px] left-3 justify-start lg:bottom-6 lg:left-0 lg:justify-center',
        arrowPrev:
          'top-auto bottom-1/2 left-6 h-[54px] w-[54px] translate-y-1/2',
        arrowNext:
          'top-auto right-6 bottom-1/2 h-[54px] w-[54px] translate-y-1/2'
      },
      brand: {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 lg:left-10',
        image: 'h-90',
        banner: 'h-90',
        title: 'text-[32px]',
        text: 'text-lg',
        button: 'mt-6',
        content:
          'absolute top-1/2 -translate-y-1/2 transform p-4 lg:ml-35 lg:max-w-[640px] lg:px-0',
        dots: 'bottom-6 pl-4 lg:pl-35',
        arrow: 'mt-4.5'
      },
      category: {
        breadcrumbs: 'left-5 lg:left-12',
        image: 'h-[500px] lg:h-150',
        banner: 'h-full lg:min-h-150',
        title: 'text-2xl font-normal tracking-wide lg:text-[32px]',
        text: 'mt-3 text-base leading-[1.4] font-light lg:mt-4 lg:text-lg',
        content: 'bottom-1/2 w-full max-w-[100%] translate-y-1/2 px-3 lg:px-24',
        button: 'min-w-auto px-10',
        buttonWrapper:
          'mt-7 grid w-1/2 w-[710px] max-w-full grid-cols-1 gap-3 lg:mt-8 lg:grid-cols-2'
      },
      product: {
        image: 'h-[237px] max-h-full lg:h-50 lg:min-h-100',
        banner: 'max-h-full',
        title: 'text-2xl font-medium tracking-[0.04em]',
        text: 'hidden tracking-[0.02em] lg:block',
        content:
          'right-3 bottom-8 left-3 translate-none lg:right-8 lg:bottom-8 lg:left-8 lg:translate-none lg:pr-[30%]',
        button:
          'right-0 bottom-0 mt-4 min-w-auto px-10 lg:absolute lg:mt-7 lg:mt-8 lg:max-w-[25%]'
      },
      blog: {
        image: 'h-full',
        banner: 'h-125 lg:h-135',
        title: 'text-2xl font-normal tracking-wide',
        text: 'mt-2 text-base leading-[1.4] font-light',
        content:
          'right-3 bottom-6 left-3 max-w-full translate-none lg:right-6 lg:bottom-6 lg:left-6 lg:translate-none',
        button: 'mt-6 min-w-auto px-10'
      },
      info: {
        image: 'h-full',
        banner: 'h-47 lg:h-74',
        title: 'z-1 text-lg font-normal tracking-wide lg:text-2xl',
        content:
          'text-text-main-inversion top-6 right-5 bottom-4 left-5 flex max-w-full translate-none flex-col items-start justify-between lg:bottom-4 lg:translate-none',
        link: 'absolute -top-6 -right-5 -bottom-4 -left-5 flex items-end justify-start pb-4 pl-5 text-base hover:bg-[#10060133]',
        arrow:
          'text-text-main-inversion [&>path]:stroke-text-main-inversion -translate-y-[2px] -rotate-90'
      }
    },
    mode: {
      light: {
        title: 'text-text-main-inversion leading-[1.2]',
        text: 'text-text-main-inversion',
        description: 'text-text-main-inversion'
      },
      dark: {
        breadcrumbs: 'text-contrast',
        title: 'text-contrast leading-[1.2]',
        text: 'text-contrast',
        description: 'text-contrast',
        arrowPrev: 'text-contrast bg-white/10 hover:opacity-70',
        arrowNext: 'text-contrast bg-white/10 hover:opacity-70'
      }
    },
    alignText: {
      center: {},
      bottomLeft: {},
      centerLeft: {}
    },
    alignHeight: {
      auto: {}
    },
    bannerMain: {
      true: {
        image: 'h-62 lg:h-100',
        banner: 'h-full lg:min-h-100',
        breadcrumbs: 'left-3 text-white max-lg:top-6 lg:left-10',
        content:
          'bottom-6 left-0 translate-y-0 lg:bottom-8 lg:left-10 lg:translate-y-0 lg:px-0',
        text: 'mt-1.5 text-[12px] font-light lg:mt-1.5 lg:text-[12px]',
        wrapper: 'relative'
      }
    }
  },
  compoundVariants: [
    {
      type: 'main',
      mode: 'dark',
      className: {
        title: 'text-main lg:text-contrast',
        text: 'text-main lg:text-contrast',
        description: 'text-main lg:text-[18px] lg:leading-[1.5] lg:text-[#fff]'
      }
    },
    {
      type: 'category',
      alignText: 'center',
      className: {
        content:
          'bottom-1/2 left-1/2 max-w-[100%] -translate-x-1/2 translate-y-1/2 px-6 text-center lg:left-1/2 lg:ml-0 lg:-translate-x-1/2',
        buttonWrapper: 'mr-auto ml-auto justify-center'
      }
    },
    {
      type: 'category',
      alignText: 'bottomLeft',
      className: {
        content: 'bottom-8 translate-y-0 lg:bottom-13.5 lg:translate-y-0'
      }
    },
    {
      type: 'category',
      alignHeight: 'auto',
      className: {
        banner: 'l-0 b-0 r-0 static top-0 sm:absolute lg:min-h-0',
        image: 'h-[237px] sm:h-auto lg:h-full',
        carousel: 'static',
        content: 'max-xl:pr-0 lg:bottom-8 lg:px-8 xl:pr-[40%]',
        title: 'lg:text-2xl',
        text: 'hidden leading-[1.2] sm:block lg:mt-1 lg:text-base',
        buttonWrapper:
          'absolute right-8 bottom-0 max-w-[35%] justify-end max-xl:static max-xl:max-w-full max-xl:justify-start max-sm:mt-4',
        button: 'h-auto px-8 py-3'
      }
    }
  ],
  defaultVariants: {
    type: 'main'
  }
});
